
<p class="has-text-start mt-2">
  <a v-if="status && !onlyIcon" class="button is-static">{{ status }}</a>
  <a v-else @click.prevent="geolocate()" class="button p-0"  href="#">
    <img v-if="showIcon && !onlyIcon" class="location-svg pr-2" src="@/images/header/crosshairs-gps.svg" alt="Use current location">
    <span v-if="!onlyIcon" class="main-txt">Use my current location</span>
    <button v-if="onlyIcon" @click="geolocate()" class=" flex justify-center items-center">
      <img 
        :class="[iconHeight ? `${iconHeight}` : 'h-7']"
        src="@/images/location.svg" 
        alt="Location icon"
      >
    </button>
  </a>
</p>
